<template>
  <div class="row card">
    <div class="col s12 m12 animated flash">
      <h5>iRecharge TERMS OF SERVICE</h5>
      <p class="text-justify">
        Welcome to iRecharge and thank you for using our service.
      </p>
      <p class="text-justify">
        iRecharge (“the mobile solution”, “service”) is a mobile solution that
        enables users recharge/pay for virtual products and services such as
        airtime, mobile data, internet subscriptions, pay TV, region specific
        prepaid power, and other bill payments. iRecharge is powered by
        Infostrategy Technology. In this agreement, ‘you’ or ‘your’ means the
        users of this mobile application and its services, ‘we’, ‘us’ or ‘our’
        refers to Infostrategy Technology.
      </p>
      <p class="text-justify">
        By using this application via web or mobile, you agree to these terms
        (‘the iRecharge terms of service’). PLEASE READ THESE TERMS AND
        CONDITIONS OF USE CAREFULLY. BY USING iRecharge, YOU INDICATE YOUR
        ACCEPTANCE OF THESE TERMS AND CONDITIONS OF USE. IF YOU DO NOT ACCEPT
        THESE TERMS AND CONDITIONS OF USE, THEN YOU MAY NOT MAKE ANY PURCHASES
        OR BILL PAYMENTS ON iRecharge.
      </p>
      <h5>USE OF SOFTWARE AND CONTENT</h5>
      <p class="text-justify">
        You may use iRecharge based on this terms of service. Any use outside of
        these terms will be considered as misuse of the mobile solution. <br />
        The logo and designs of the application are owned by Infostrategy
        Technology. You are not allowed to do the following:
      </p>
      <ul>
        <li>
          Copy, edit, reproduce, publish, distribute, store, commercially
          exploit these trademarks
        </li>
        <li>To reverse engineer, alter or modify any part of the software</li>
        <li>
          Use or launch any automated system, including without limitation,
          "robots," "spiders," "offline readers," etc. or "load testers" such as
          wget, apache bench, mswebstress, httpload, blitz, Xcode Automator,
          Android Monkey, etc., that accesses the Service in a manner that sends
          more request messages to the iRecharge servers in a given period of
          time than a human can reasonably produce in the same period by using
          iRecharge mobile app.
        </li>
        <li>
          Post, publish, modify, transmit, reproduce, or distribute in any way,
          information, software or other materials or tools designed for the
          security of the Communication Services, our network or
          telecommunication services.
        </li>
      </ul>
      <p class="text-justify">
        To use the software and its content, you agree to provide and abide by
        the following:
      </p>
      <ul>
        <li>
          Your personal information such as working Email and phone number.
        </li>
        <li>
          Update the software in mobile device whenever there is an available
          update.
        </li>
        <li>
          You must secure our permission before you measure, test, health check
          or otherwise monitor any network equipment, servers or assets hosted
          on our domain.
        </li>
      </ul>
      <h5>DISCLAIMER</h5>
      <p class="text-justify">
        YOU AGREE THAT YOUR USE OF iRecharge SHALL BE AT YOUR SOLE RISK AND TO
        THE FULLEST EXTENT PERMITTED BY LAW. iRecharge STAFF AND EXECUTIVES HERE
        AND NOW DISCLAIM EXPRESSIVELY ALL WARRANTIES IN CONNECTION WITH THE
        SERVICE AND YOUR USE THEREOF. iRecharge OR ITS DEVELOPERS (INFOSTRATEGY
        TECHNOLOGY) MAKES NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY,
        ERROR-FREE STATE OF ITS CONTENT AND SERVICE AND ASSUMES NO LIABILITY AND
        RESPONSIBILITY FOR ERRORS, MISTAKES, INACCURACY, PERSONAL AND EMOTIONAL
        INJURY , DAMAGE OF PROPERTY OR ANY NATURE WHATSOEVER RESULTING FROM USE
        AND ACCESS OF iRecharge. <br />
        WE TAKE NO LIABILITY OR RESPONSIBILITY FOR ANY UNAUTHORISED ACCESS AND
        USE OF iRecharge OR ANY/OR ALL PERSONAL AND FINANCIAL INFORMATION STORED
        THEREIN, ANY INTERRUPTION OF TRANSMISSION TO OR FROM OUR SERVICE, BUGS,
        VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR
        THROUGH iRecharge THROUGH THE ACTIONS OF ANY THIRD PARTY, AND/OR ANY
        ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS OR DAMAGE OF ANY KIND
        INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, EMAILED,
        TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA iRecharge. iRecharge OR ITS
        DEVELOPER DOES NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY
        FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY
        THROUGH iRecharge OR ANY HYPERLINKED WEBSITE OR FEATURED IN ANY USER
        STATUS SUBMISSION OR OTHER ADVERTISING, AND iRecharge OR ITS DEVELOPER
        WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY
        TRANSACTION BETWEEN YOU AND THIRD-PARTY PROVIDERS OF PRODUCTS OR
        SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY
        MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND
        EXERCISE CAUTION WHERE APPROPRIATE.
      </p>
      <h5>PRIVACY POLICY</h5>
      <p class="text-justify">
        This privacy policy describes your rights regarding our collection, use,
        storage, sharing and protection of your personal information which you
        provide for use of iRecharge. <br />
        When you complete any form, speak with our staff or submit any details
        to us or use our App, we will collect, use and disclose your personal
        information in the manner described in this Privacy Policy.
      </p>
      <h5>INFORMATION WE COLLECT</h5>
      <p class="text-justify">
        The information we collect about you may be:
      </p>
      <ul>
        <li>Personal data such as email address, telephone number</li>
        <li>
          Financial data such as amount involved in transaction, available
          balance and transaction history of your iRecharge account.
        </li>
        <li>Correspondence that you send us</li>
        <li>Calls that we make to you or you make to us</li>
        <li>Device make, model and carrier network</li>
      </ul>
      <h5>INFORMATION WE DON’T COLLECT</h5>
      <ul>
        <li>
          We do not store cookies about you since you will be downloading the
          app directly from your device’s app market
        </li>
        <li>
          Financial data such as bank or payment card details(including, but not
          limited to, account name, account number, sort code, online banking
          PIN, Transaction Authentication Number “TAN” and password), or payment
          gateway like Quickteller details.
        </li>
      </ul>
      <h5>INFORMATION WE COLLECT ABOUT YOU FROM THIRD PARTIES</h5>
      <p class="text-justify">
        Sometimes we may collect information about you from third parties such
        as credit/debit Card Company or processor, bank, social media sites and
        payment gateway. The information we receive varies and is controlled by
        the third party site or application. <br />
        By associating an account managed by a third party with your iRecharge
        account and authorizing iRecharge to have access to this information,
        you agree that iRecharge may collect, store and use this information in
        accordance with this Privacy Policy.
      </p>
      <h5>HOW WE USE THE INFORMATION WE COLLECT</h5>
      <p class="text-justify">
        All the information we collect from you and about you are used in the
        following ways:
      </p>
      <ul>
        <li>To operate and administer your iRecharge account.</li>
        <li>
          To carry out your instructions to make payments and undertake your
          transactions using our service and send you notification of the
          transaction and payment.
        </li>
        <li>To notify you about changes to our terms.</li>
        <li>To communicate with you on updates, complaints and feedbacks</li>
        <li>To improve our internal customer training.</li>
        <li>
          For customer service including answering questions and responding to
          feedback and complaints.
        </li>
        <li>To enhance security to our app and the iRecharge account.</li>
      </ul>
      <h5>HOW WE STORE AND PROTECT YOUR INFORMATION</h5>
      <p class="text-justify">
        We store and process your information on our server. We protect your
        information from illegal and unauthorized access through the use of
        physical, technical and administrative security measures some of which
        is the use of firewalls, data encryption, physical access controls to
        our database and information access authorization controls. <br />
        To effectively protect your information, do not share your card details
        or email account details with anyone.
      </p>
      <h5>HOW WE SHARE YOUR INFORMATION WITH THIRD PARTY</h5>
      <p class="text-justify">
        We disclose your information with third party only in ways described in
        this policy.
      </p>
      <ul>
        <li>
          We do not and will never sell your information to any third party. We
          require these third parties to not use your information for any other
          purpose.
        </li>
        <li>
          We may disclose your information such as payment details, name etc for
          payment processing.
        </li>
        <li>
          We may disclose your information to a prospective share holder of the
          app or buyer.
        </li>
        <li>
          We may disclose your information to the police or other law
          enforcement body or regulatory body as long as a court order is
          provided for such information.
        </li>
        <li>
          Third party social media sites that you have chosen to share your
          purchase information with. Example, if you wish to have a product you
          purchased using the iRecharge account shared on Facebook, twitter,
          Instagram, WhatsApp, etc.
        </li>
      </ul>
      <h5>WHAT WE SHARE WITH THIRD PARTY</h5>
      <ul>
        <li>We do not sell your personal information with any third party</li>
        <li>
          We may share certain information about you with a third party that you
          extend that right or privilege to.
        </li>
        <li>
          In the event iRecharge is bought or we have new investors, your
          personal information will be provided to the new buyer or investor.
        </li>
      </ul>
      <h5>YOUR RIGHTS</h5>
      <ul>
        <li>You may choose to provide your personal information.</li>
        <li>You may choose to subscribe for notifications from us.</li>
        <li>
          You may choose whatever payment method you desire for iRecharge.
        </li>
      </ul>
      <h5>YOUR RESPONSIBILITY</h5>
      <ul>
        <li>
          You are responsible for ensuring your mobile device is connected to a
          mobile internet connection or Wi-Fi connection.
        </li>
        <li>
          You are responsible for any charge that the use of mobile internet
          connection/Wi-Fi may incur.
        </li>
        <li>
          You are responsible for keeping the &nbsp;iRecharge app software on
          your mobile device up-to-date.
        </li>
      </ul>
      <h5>OUR COMMUNICATION WITH YOU</h5>
      <p class="text-justify">
        We will communicate with you through text messages, emails or phone
        calls. We will never require you to disclose your card details or email
        details. Communication can also be made with us through:
      </p>
      <p class="text-left">
        <strong>Website:</strong> istrategytech.com <br />
        <strong>Email:</strong> hello@istrategytech.com <br />
        <strong>Address:</strong> No. 3 kaltungo street, Egbedi Street, off
        Samuel Ladoke Akintola Boulevard, Garki 2 Abuja, Nigeria. <br />
        <strong>Telephone:</strong>
        <a href="tel:+2348149906336">+234 814 990 6336</a>
      </p>
      <p class="text-justify">
        Your use of the iRecharge app and website and /or any other information
        exchange media, made available by us “INFOSTRATEGY TECHNOLOGY”
        (collectively called “iRecharge”) is governed by these Terms of Service.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'About',
  components: {},
  mounted() {
    $('.bills__side__wrapper').removeClass('left_out')
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style scoped>
.social-links.d-flex.justify-content-center a.btn-social-icon {
  background-color: #fa6e36;
  margin: 0px 10px;
  border-radius: 0px;
}
.card {
  padding: 15px 20px;
}
ul li {
  list-style-type: circle;
  text-align: left;
}
</style>
